import SLAMPDF from '../assets/project-files/Robotics in Nuclear Operations.pdf';
import CarbonSmartPDF from '../assets/project-files/CarbonSmart.pdf';
import WearYourConfidencePDF from '../assets/project-files/WearYourConfidence.pdf';
import PetMatePDF from '../assets/project-files/PetMate.pdf';
import DyscoverAIPDF from '../assets/project-files/DyscoverAI.pdf';

export const projectsData = [
    {
        id: 1,
        title: "SLAM Localization Model",
        category: "ai-ml",
        description: "Improved localization accuracy in traditional SLAM models using Gated Recurrent Unit (GRU) networks in MATLAB by 64%.",
        icon: "🤖",
        tags: ["MATLAB", 
                "Gated Recurrent Unit", 
                "Computer Vision", 
                "Feature Extraction",
                "Feature Tracking", 
                "Robotics",
                "Nuclear Industry",
                "Localisation",
                "Mapping",
                "Light Detection (through LiDAR)",
            ],
        link: SLAMPDF,
        linkType: "file",
        date: 'February 2025',
    },
    {
        id: 2,
        title: "Carbon Smart",
        category: "full-stack",
        description: "A smartphone application to track and reduce personal carbon footprints with real-time monitoring, public transport suggestions, and sustainable shopping assistance.",
        icon: "🌱",
        tags: [
            "Agile Project Management",
            "Human Computer Interaction",
            "Software Documentation",
            "Figma",
            "User Experience (UX)",
            "User Interface Design",
            "Mobile App Development",
            "Sustainability"
        ],
        link: CarbonSmartPDF,
        linkType: "file",
        date: 'April 2024',
    },
    {
        id: 3,
        title: "Wear Your Confidence",
        category: "full-stack",
        description: "Innovative smart clothing solution to improve posture and empower overall well-being using Smart Vests, Insoles, Adaptive Clothing, and Smart Mirrors.",
        icon: "👕",
        tags: [
            "Arduino",
            "Artificial Intelligence (AI)",
            "Flutter",
            "Arduino IDE",
            "Problem Solving",
            "Software Development",
            "Software Documentation",
            "Wearable Technology",
            "Internet of Things (IoT)"
        ],
        link: WearYourConfidencePDF,
        linkType: "file",
        date: 'April 2024',
    },
    {
        id: 4,
        title: "PetMate",
        category: "full-stack",
        description: "A web platform connecting pet-owners with reliable pet-sitters, providing a safe and convenient service for both parties.",
        icon: "🐾",
        tags: [
            "CSS",
            "JavaScript",
            "Java",
            "SQL",
            "HTML",
            "Angular",
            "Agile Project Management",
            "Software Development",
            "Software Documentation",
            "Software Engineering",
            "Web Development"
        ],
        link: PetMatePDF,
        linkType: "file",
        date: 'May 2023',
    },
    {
        id: 5,
        title: "DyscoverAI",
        category: "ai-ml",
        description: "A full-stack system with deep learning models to detect learning disabilities in children and young adults using handwriting analysis.",
        icon: "🧠",
        tags: [
            "Python", 
            "Handwriting Image Analysis", 
            "Machine Learning",
            "Neural Networks", 
            "TensorFlow", 
            "Keras", 
            "MobileNetV2",
            "SVM",
            "Feature Extraction", 
            "REST API", 
            "Docker", 
            "React", 
            "Vite", 
            "Flask", 
            "AWS EC2",
            "Grad-CAM", 
            "UI/UX"],
        link: DyscoverAIPDF,
        linkType: "file",
        date: 'April 2025',
    },
];